import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemIcon, itemIcons } from './itemIcons';

type Props = { value: ItemIcon; onChange: (icon: ItemIcon) => void };

export default function IconPicker({ value, onChange }: Props) {
  const { t } = useTranslation();
  const ref = useRef<HTMLDetailsElement>(null);
  const Selected = itemIcons[value];
  return (
    <details className="menu-icon-picker" ref={ref}>
      <summary aria-label={t('menuCustomization.chooseIcon')} title={t('menuCustomization.chooseIcon')}>
        <Selected size={20} />
      </summary>
      <div className="menu-icon-options" role="group" aria-label={t('menuCustomization.chooseIcon')}>
        {(Object.keys(itemIcons) as ItemIcon[]).map(key => {
          const Icon = itemIcons[key];
          return (
            <button type="button" key={key} aria-pressed={value === key}
              title={t(`menuCustomization.icons.${key}`)} aria-label={t(`menuCustomization.icons.${key}`)}
              onClick={() => { onChange(key); if (ref.current) ref.current.open = false; }}>
              <Icon size={20} />
            </button>
          );
        })}
      </div>
    </details>
  );
}
